var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "step23" } },
    [
      _c(
        "v-alert",
        {
          staticClass: "ma-0",
          attrs: { type: "info", outline: "", value: _vm.samples.length === 0 },
        },
        [
          _c("div", { staticClass: "primary--text" }, [
            _vm._v(
              "\n      Hmm, this station doesn't have any sample activities.\n    "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("Subheader", {
            attrs: { title: "", search: "sample activities" },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _vm._v(" "),
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.samples,
              search: _vm.search,
              pagination: _vm.pagination,
              "item-key": "id",
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function (props) {
                  return [
                    _c("tr", [
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.CocCode)),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(
                              props.item.SampleDate,
                              _vm.formats.prettyDateTimeFormat
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.SampledBy)),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.Notes)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-xs-right" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { depressed: "", small: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onItemSelected(props.item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("Button.View")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1000px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c("v-toolbar-title", [
                _vm._v(_vm._s(_vm.$t("StationDetailSampleActivity.titleMsg"))),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.dialog = false
                      _vm.isView = true
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "COC Code",
                                      required: "",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.selectedSample.CocCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedSample,
                                          "CocCode",
                                          $$v
                                        )
                                      },
                                      expression: "selectedSample.CocCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Sample Date",
                                      disabled: "",
                                      type: "text",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.selectedSample.SampleDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedSample,
                                          "SampleDate",
                                          $$v
                                        )
                                      },
                                      expression: "selectedSample.SampleDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Sampled By",
                                      disabled: _vm.isView,
                                    },
                                    model: {
                                      value: _vm.selectedSample.SampledBy,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedSample,
                                          "SampledBy",
                                          $$v
                                        )
                                      },
                                      expression: "selectedSample.SampledBy",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      label: "Notes",
                                      disabled: _vm.isView,
                                    },
                                    model: {
                                      value: _vm.selectedSample.Notes,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedSample,
                                          "Notes",
                                          $$v
                                        )
                                      },
                                      expression: "selectedSample.Notes",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-subheader",
                                    { staticStyle: { "padding-left": "0px" } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "StationDetailSampleActivity.subheadFirstMsg"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.selectedSample.Documents,
                                    function (item) {
                                      return _c(
                                        "ul",
                                        {
                                          key: item.Id,
                                          staticStyle: {
                                            "padding-left": "20px",
                                          },
                                        },
                                        [
                                          _c("li", [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: `/uploads/${item.FileName}`,
                                                  download: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      item.FileName.substr(
                                                        item.FileName.lastIndexOf(
                                                          "\\"
                                                        ) + 1
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-subheader",
                                    { staticStyle: { "padding-left": "0px" } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "StationDetailSampleActivity.subheadSecondMsg"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.selectedSample.Imports,
                                    function (item) {
                                      return _c(
                                        "ul",
                                        {
                                          key: item.id,
                                          staticStyle: {
                                            "padding-left": "20px",
                                          },
                                        },
                                        [
                                          _c("li", [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.viewImport(
                                                      item.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("format")(
                                                      item.created_at
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isView,
                              expression: "!isView",
                            },
                          ],
                          attrs: { color: "success" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.saveSample.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isView,
                              expression: "isView",
                            },
                          ],
                          attrs: { color: "warning", light: "" },
                          nativeOn: {
                            click: function ($event) {
                              _vm.isView = false
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("edit"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Edit")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isView
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "secondary", outline: "" },
                              nativeOn: {
                                click: function ($event) {
                                  _vm.isView = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Button.Cancel")) + "\n          "
                              ),
                            ]
                          )
                        : _c(
                            "v-btn",
                            {
                              attrs: { color: "secondary", outline: "" },
                              nativeOn: {
                                click: function ($event) {
                                  _vm.dialog = false
                                  _vm.isView = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("Button.Close"))
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }